import { Component, OnInit } from '@angular/core';
import { DataService } from '../services/data-service.service';
import { WizardStore } from '../stores/wizard-store.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-discuss',
  templateUrl: './discuss.component.html',
  styleUrls: ['./discuss.component.scss']
})
export class DiscussComponent implements OnInit {

  jobId: string;
  employerId: string;

  private subscriptions: Subscription[] = [];
  
  constructor(public wizardStore: WizardStore,
    private dataService: DataService) { 
       this.subscriptions.push(this.wizardStore.selectedJobId.subscribe(j => this.jobId = j));
       this.subscriptions.push(this.wizardStore.employerId.subscribe(e => this.employerId = e));
    }

  ngOnInit(): void {
    const jobId = this.wizardStore.getSelectedJobId();
    this.wizardStore.getCandidateProfileInfos(jobId);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  onHireClicked(): void {
    this.wizardStore.step = 4;
  }

}
